module.exports = __webpack_public_path__ + "static/media/about.61c0c952.png";